import "zone.js/dist/zone";

// RxJS
import "rxjs";

// Angular 2.
import "@angular/common";
import "@angular/core";
import "@angular/http";
import "@angular/forms";
import "@angular/platform-browser";
import "@angular/platform-browser-dynamic";
import "@angular/router";

// Reflect Metadata.
import "reflect-metadata";

// Plugins
import "ng2-bootstrap/components/tabs";
import "sweetalert2";
import "underscore";
import "@ng-bootstrap/ng-bootstrap";

// Other libraries.
import "jquery/src/jquery";
import "bootstrap/dist/js/bootstrap";

// CSS dependencies
import "sweetalert2/dist/sweetalert2.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap-theme.css";

// Font awesome
import "font-awesome/css/font-awesome.css";




// WEBPACK FOOTER //
// ./src/vendor.ts